import { SortedInfoType } from "../hook/useSort/models"

export const getSortOrder = (sortedInfo: SortedInfoType, key: string) =>
  sortedInfo && sortedInfo.columnKey === key ? sortedInfo.order : null
